import { Component, OnInit } from '@angular/core';
import { filter } from 'rxjs/operators';
import { FilterWCupRankingService } from '../../services/filter-wcup-ranking.service';

@Component({
  selector: 'app-wcup-ranking-filters',
  templateUrl: './wcup-ranking-filters.component.html',
  styleUrls: ['./wcup-ranking-filters.component.scss']
})
export class WCupRankingFiltersComponent implements OnInit {
  constructor(public filter_service: FilterWCupRankingService) {}

  ngOnInit() {}
}
